/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalletLineItem } from './PalletLineItem';
import {
    PalletLineItemFromJSON,
    PalletLineItemFromJSONTyped,
    PalletLineItemToJSON,
    PalletLineItemToJSONTyped,
} from './PalletLineItem';

/**
 * 
 * @export
 * @interface PalletPackItem
 */
export interface PalletPackItem {
    /**
     * 已有托盘 id；新建不传
     * @type {number}
     * @memberof PalletPackItem
     */
    palletId?: number;
    /**
     * 唛头号
     * @type {string}
     * @memberof PalletPackItem
     */
    markNo: string;
    /**
     * 托盘类型：1 库存 2 运输
     * @type {number}
     * @memberof PalletPackItem
     */
    palletType: number;
    /**
     * 订单 id（可与外层 orderId 一致）
     * @type {number}
     * @memberof PalletPackItem
     */
    orderId?: number;
    /**
     * 重量 kg
     * @type {number}
     * @memberof PalletPackItem
     */
    wtKg?: number;
    /**
     * CBM 立方米
     * @type {number}
     * @memberof PalletPackItem
     */
    cbm: number;
    /**
     * 长 cm
     * @type {number}
     * @memberof PalletPackItem
     */
    length?: number;
    /**
     * 宽 cm
     * @type {number}
     * @memberof PalletPackItem
     */
    width?: number;
    /**
     * 高 cm
     * @type {number}
     * @memberof PalletPackItem
     */
    height?: number;
    /**
     * 是否箱子当托盘：0 否 1 是
     * @type {number}
     * @memberof PalletPackItem
     */
    boxAsPallet?: number;
    /**
     * 托盘明细
     * @type {Array<PalletLineItem>}
     * @memberof PalletPackItem
     */
    details: Array<PalletLineItem>;
}

/**
 * Check if a given object implements the PalletPackItem interface.
 */
export function instanceOfPalletPackItem(value: object): value is PalletPackItem {
    if (!('markNo' in value) || value['markNo'] === undefined) return false;
    if (!('palletType' in value) || value['palletType'] === undefined) return false;
    if (!('cbm' in value) || value['cbm'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function PalletPackItemFromJSON(json: any): PalletPackItem {
    return PalletPackItemFromJSONTyped(json, false);
}

export function PalletPackItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalletPackItem {
    if (json == null) {
        return json;
    }
    return {
        
        'palletId': json['palletId'] == null ? undefined : json['palletId'],
        'markNo': json['markNo'],
        'palletType': json['palletType'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'cbm': json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'boxAsPallet': json['boxAsPallet'] == null ? undefined : json['boxAsPallet'],
        'details': ((json['details'] as Array<any>).map(PalletLineItemFromJSON)),
    };
}

export function PalletPackItemToJSON(json: any): PalletPackItem {
    return PalletPackItemToJSONTyped(json, false);
}

export function PalletPackItemToJSONTyped(value?: PalletPackItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'palletId': value['palletId'],
        'markNo': value['markNo'],
        'palletType': value['palletType'],
        'orderId': value['orderId'],
        'wtKg': value['wtKg'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'boxAsPallet': value['boxAsPallet'],
        'details': ((value['details'] as Array<any>).map(PalletLineItemToJSON)),
    };
}

